import React, { memo } from 'react';
import { View, Image } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';
import { Text, Space } from '@redlink/components/atoms';

export const PreviewResumeQR = memo(({ qrCode, size, style }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();
  return (
    <View style={[styles.container, style]}>
      <Image source={{ uri: qrCode }} style={[styles.image, size && {width: size, height: size, resizeMode: 'contain'}]} />
      <Space size={8} />
      <Text style={styles.text}>{dictionary.scanToAccessMyRedlink}</Text>
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    alignItems: 'center',
  },
  image: {
    width: 112,
    height: 112,
    backgroundColor: colors.white,
  },
  text: {
    fontSize: 12,
    lineHeight: 17,
    color: colors.title,
  },
}));
